/**
 * @ComponentFor LoginPageViewModel
 */

import React, { useEffect, useState } from 'react';
import { styled } from '@glitz/react';
import LoginPageType from './LoginPageViewModel.type';
import Page from 'Shared/Page';
import connect from 'Shared/connect';
import { setImageBackground, Preset } from 'Shared/image-background';
import LoginModal, { ModalView } from 'SiteLayout/AccountBox/LoginModal';
import { myAccountPage } from 'Shared/known-urls';
import { isCompact } from 'Shared/Viewport';
import { selectDeviceImageFromProperty } from 'Shared/utils';

type ConnectedPropType = {
  currentBreakpoint: number;
  headerHeight: number;
};

const Wrap = styled.div({
  transition: { property: ['transform'], duration: 300, timingFunction: 'ease' },
  width: '100vw',
  background: {
    size: 'cover',
    positionX: 'center',
    positionY: 'center',
  },
  display: 'flex',
  justifyItems: 'center',
  alignItems: 'center',
})

const LoginPage = (props: LoginPageType & ConnectedPropType) => {
  const { currentBreakpoint, headerHeight, loginViewModel } = props;
  const [modalIsOpen, SetModalIsOpen] = useState(false);
  const isMobile = isCompact(currentBreakpoint);

  useEffect(() => {
    SetModalIsOpen(true);
  }, []);

  return (
    <Page>
      <Wrap
        css={{
          height: `calc(100vh - ${headerHeight}px)`,
          background: {
            image: setImageBackground(selectDeviceImageFromProperty(props.page.image, props.page.imageSmallScreen, isMobile)?.url, Preset.FullWidth),
          },
        }}
      ></Wrap>
      <LoginModal
        isOpen={modalIsOpen}
        hideModal={() => { }}
        startModalView={ModalView.Login}
        redirectOnLogin={true}
        redirectToAfterLogin={myAccountPage()}
        isCompact={isCompact(currentBreakpoint)}
        preloadedLoginView={loginViewModel}
        isWide
        backgroundDisabled
      />
    </Page>
  );
};

export default connect((state) => ({
  currentBreakpoint: state.currentBreakpoint,
  headerHeight: state.UI?.headerHeight,
}))(LoginPage);
